import { AlertType, getAlertTypeLabel } from '@aloft/toolkit-shared';

import { useEffect, useRef } from 'react';

import { useAlerts } from '../modules/referenceView/AlertsSheet/hooks/useAlerts.tsx';
import { selectTriggeredAlerts } from '../redux/features/selectors/uiSelectors.ts';
import { useAppSelector } from '../redux/hooks.ts';
import { useToaster } from './useToaster/useToaster.tsx';

export const useTriggeredAlertToasts = () => {
  const makeToast = useToaster();
  const triggeredAlerts = useAppSelector(selectTriggeredAlerts);
  const alerts = useAlerts();
  const alertsRef = useRef(alerts);
  alertsRef.current = alerts;

  useEffect(() => {
    if (triggeredAlerts.length === 0) {
      return;
    }

    const alertsSnapshot = alertsRef.current;
    const allAlerts = [
      ...alertsSnapshot.adjustments,
      ...alertsSnapshot.comparable,
      ...alertsSnapshot.depreciatedCost,
    ];

    triggeredAlerts.forEach((type: AlertType) => {
      const alert = allAlerts.find((candidate) => candidate.type === type);
      if (!alert || alert.status !== 'active') return;

      makeToast({
        id: `alert-${type}`,
        type: alert.severity,
        title: getAlertTypeLabel(type),
        body: alert.message,
        compType: alert.compType,
        comparablesAlerts: true,
        openAlertsOnClick: true,
      });
    });
  }, [makeToast, triggeredAlerts]);
};
